import Splide from "@splidejs/splide";

const splideSliders = document.querySelectorAll(".splide");
const splideMap = new Map();
if (splideSliders.length) {
    Array.from(splideSliders).forEach((splideSlider, index) => {
        let settings = {
            type: "slide",
            arrows: index == 0 ? true : false,
            perPage: index == 0 ? 1 : 6,
            pagination: false,
            perMove: 1,
            isNavigation: true,
            fixedHeight: index == 0 ? 350 : 80,
            gap: index == 0 ? 30 : 0,
        };

        settings = { ...settings, isNavigation: true };

        const splide = new Splide(splideSlider, settings);
        const progressbarSelector = splideSlider.dataset.splideProgressbar;
        const progressbar = progressbarSelector ? splide.root.querySelector(progressbarSelector) : null;

        if (progressbar) {
            // Updates the bar width whenever the carousel moves:
            splide.on("mounted move", function () {
                const end = splide.Components.Controller.getEnd() + 1;
                const rate = Math.min((splide.index + 1) / end, 1);

                progressbar.style.width = String(100 * rate) + "%";
            });
        }
        splideMap.set(splideMap.size, splide);
        splide.mount();
    });
}

splideMap.get(0)?.sync(splideMap.get(1));
